import { render, staticRenderFns } from "./receivablesInvoiceDetails.vue?vue&type=template&id=6e89214a&scoped=true"
import script from "./receivablesInvoiceDetails.vue?vue&type=script&lang=js"
export * from "./receivablesInvoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./receivablesInvoiceDetails.vue?vue&type=style&index=0&id=6e89214a&prod&lang=css"
import style1 from "./receivablesInvoiceDetails.vue?vue&type=style&index=1&id=6e89214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e89214a",
  null
  
)

export default component.exports